export const STOP_NUMBER_MAP = new Map([
  ["-1", "Any number of stops"],
  ["0", "Non-stop only"],
  ["1", "1 stop or fewer"],
  ["2", "2 stop or fewer"],
]);

export const CABIN_TYPE = new Map([
  ["Economy & Premium Economy", "Economy & Premium Economy"],
  ["Business & First", "Business & First"],
]);

export const ROUTES_STOPS_OPTIONS = [
  {
    name: "Any number of stops",
    value: "has stops",
  },
  {
    name: "Non-stop only",
    value: "nonstop",
  },
];
